import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';

export const columnFields = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s10,
});

export const rowFields = style([
  columnFields,
  responsiveStyle({
    mobile: {
      selectors: {
        '&:is(&)': {
          flexDirection: 'column',
        },
      },
    },
    tablet: {
      selectors: {
        '&:is(&)': {
          flexDirection: 'row',
        },
      },
    },
  }),
]);

globalStyle(`${rowFields} > div`, {
  flex: '1 1 0',
  minWidth: 0,
});

export const streamFormTrigger = style([
  {
    width: '100%',
  },
]);

export const streamFormActions = style([
  {
    marginTop: space.s20,
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    gap: space.s8,
  },
]);

export const textBetweenFields = style([
  {
    margin: `auto ${space.s2}px`,
  },
]);

export const createStreamFormActions = style([
  responsiveStyle({
    mobile: {
      marginTop: space.s32,
      justifyContent: 'center',
    },
    tablet: {
      marginTop: space.s16,
      justifyContent: 'end',
    },
  }),
]);

export const formInfoBlock = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s10,
  },
  responsiveStyle({
    mobile: {
      marginTop: space.s10,
      marginBottom: space.s8,

      selectors: {
        '&:first-child': {
          marginTop: 0,
        },
      },
    },
    tablet: {
      marginTop: space.s16,
      marginBottom: space.s14,

      selectors: {
        '&:first-child': {
          marginTop: 0,
        },
      },
    },
  }),
]);

export const formInfoTitle = style([
  typography.titleMd,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
  },
]);

export const formInfoDescription = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
  },
]);

export const paidStreamDataContainer = style([
  columnFields,
  {
    gap: space.s24,
  },
]);

export const actionLink = style([
  typography.bodyMd,
  {
    color: themeVars.link.idle,
    ':hover': {
      textDecoration: 'underline',
    },
  },
]);

export const checkbox = style([
  typography.bodyMd,
  {
    display: 'flex',
    gap: space.s8,
    alignItems: 'center',
  },
]);

export const streamTypeStepContainer = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s20,
    marginBottom: space.s14,
  },
]);
